'use client'

import { SberCredit } from '@/screens/SberCredit'

const ServicesCreditSberPageContent = () => {
	return <SberCredit />
}

export function ServicesCreditSberClient() {
	return <ServicesCreditSberPageContent />
}
